import {ECpmCUserTypeApiEnum, RECpmCUserTypeApiEnum} from '../../../gen/cpm-c-api-ts/src/enums/cpmc-sdk.api-enums';
import {TableTagDef} from '../../../sdk/src/components/generic-table/table-col-def';
import {StringUtils} from '../../../sdk/src/utils/string.util';

/**
 * User util
 */
export abstract class UserUtils {
    public static readonly typeOptions = Object.keys(ECpmCUserTypeApiEnum).map((key) => ({
        label: StringUtils.toHumanFormatedStr(key).replaceAll('M2m', 'M2M'),
        value: RECpmCUserTypeApiEnum[key]
    }));

    public static readonly typeDescriptions: Record<string, string> = {
        ['SUPER_ADMIN']: 'Super admin user, have permissions on everything!',
        ['SUPER_ADMIN_M2M']: 'Machine2Machine/Api, same permissions as SUPER_ADMIN',
        ['USER']: 'Regular user, can connect to the app and see the customers it had been added to',
        ['M2M']: 'Machine2Machine/Api, same permissions as USER'
    };

    // ===============================================================
    // ===============================================================

    /**
     * Generate the table tag defs
     * @param generateColorFromString Generate color from string method
     * @returns Generated table tag defs
     */
    public static getTypeTableTagDefs(generateColorFromString: (str: string) => string): TableTagDef[] {
        return UserUtils.typeOptions.map((x) => ({
            style: {background: generateColorFromString(x.label)},
            label: x.label,
            value: x.value,
            tooltip: this.typeDescriptions[x.value]
        }));
    }
}
